import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import { WelcomeScreen } from "@/components/WelcomeScreen";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Passes from "@/pages/Passes";
import Amenities from "@/pages/Amenities";
import Visit from "@/pages/Visit";
import FAQ from "@/pages/FAQ";

function App() {
  return (
    <div className="App">
      <WelcomeScreen />
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <div className="page-grain" />
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/passes" element={<Passes />} />
              <Route path="/amenities" element={<Amenities />} />
              <Route path="/visit" element={<Visit />} />
              <Route path="/faq" element={<FAQ />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#000000",
                color: "#F0E9DA",
                border: "1px solid #B93407",
                borderRadius: "0",
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
              },
            }}
          />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
